import { Calendar } from '../features/calendar/calendar-slice';

export function formatAddress(calendar: Calendar) {
  const alias = calendar.alias ? calendar.alias : calendar.laboratory ? calendar.laboratory.title : '';
  const inviteFisicalAddress = calendar.laboratory ? calendar.laboratory.adress : calendar.inviteFisicalAddress;
  return [alias, inviteFisicalAddress];
}
